/* eslint id-length: [2, {"exceptions":["a","b"]}] */
import mori from 'mori';
// import { getDefaultStates } from '../config/table';
import { buildRowData, getAgColumns } from './table';

/**
 * [filterByTimeframe description]
 * @TODO build out doc
 * @param  {[type]} data    [description]
 * @param  {[type]} options [description]
 * @return {[type]}         [description]
 */
export function filterByTimeframe(data, options) {
  // Get the list of selected timeframes by name
  // @TODO logic for selecting by timeframe gets a little weird for defaults
  // and range vs single, could refactor this
  let activeTimeframe = +(options.currentTimeframe || 0);
  let endTimeframeOffset = 1;
  if (options.activeTab === 'graph') {
    if (!options.startTimeframe) {
      activeTimeframe = 0;
    }
    const startTimeframe = +(options.startTimeframe || 0) + 1;
    endTimeframeOffset = options.startTimeframe ?
      startTimeframe :
      data.timeframes.length;
  } else {
    endTimeframeOffset = +(options.startTimeframe || activeTimeframe + 1);
  }

  const timeframes = mori.set((data.timeframes || [0]).slice(
    activeTimeframe,
    endTimeframeOffset
  ));

  return mori.filter(
    (sheet) => mori.hasKey(timeframes, mori.first(sheet)),
    data.immutableData
  );
}

/**
 * [buildTable description]
 * @TODO build out doc
 * @param  {[type]} data            [description]
 * @param  {[type]} options         [description]
 * @param  {[type]} timeframes      [description]
 * @param  {[type]} combinedColumns [description]
 * @param  {[type]} selectedSetKeys [description]
 * @param  {[type]} distributions   [description]
 * @param  {[type]} dataviewType    [description]
 * @param  {[type]} columnKeys      [description]
 * @return {[type]}                 [description]
 */
export function buildTable(
  data,
  options,
  timeframes,
  combinedColumns,
  selectedSetKeys,
  distributions,
  dataviewType,
  columnKeys
) {
  const trend = mori.count(timeframes) > 1;

  const geoMulti = mori.getIn(
    data.config,
    ['globalRules', 'Geomulti'],
    false
  );

  const mapBaseColumn = mori.getIn(
    data.config,
    ['globalRules', 'Map Base Column'],
    false
  );

  const linkContext = mori.getIn(
    data.config,
    ['globalRules', 'Context'],
    []
  )[1] || 'states';

  const builtRowData = buildRowData(
    timeframes,
    selectedSetKeys,
    combinedColumns,
    trend
  );

  // Build the column headers and variables for agGrid
  const columnDefs = getAgColumns(
    data.immutableHeaders,
    distributions,
    mori.getIn(data.config, ['globalRules', 'Link Column'], false),
    mori.getIn(data.config, ['globalRules', 'Link Target'], false),
    linkContext,
    dataviewType,
    timeframes,
    trend,
    mori.first(columnKeys[0]),
    geoMulti && mapBaseColumn ? mapBaseColumn : false
  );

  return mori.hashMap(
    'tableData', mori.hashMap(
      'rowData', builtRowData.rowData || [],
      'columnDefs', columnDefs,
      'selectedSetKeys', selectedSetKeys
    )
  );
}



// WEBPACK FOOTER //
// ../datacenter/app/js/services/dataFromOptions.js